import React, { ReactNode, useContext } from 'react';
import { StyledMapToolTip } from './index.styles';
import { Modal } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { MapTooltipProps } from './index.types';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import {
  dailyDestinationFeeLabel,
  dailyResortFeeLabel,
  mandatoryFeeCodes,
} from '../../organisms/SearchResults/index.constant';
import { addSubDirectoryPrefix } from '../../utils/src/helper';
import { NAVIGATION_URL_CONSTANTS } from '../../organisms/SearchResults/lib/config';
import { usePageContext } from '../../context';

export const MapToolTipComponent: React.FC<MapTooltipProps> = ({
  popupOpenState,
  setPopupOpenState,
  onCancel,
  selectedHotelRef,
  isFlexibleDateSearch,
}) => {
  const { NEXT_PUBLIC_AVAILABILITY_SEARCH_URL } = usePageContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected }: any = useContext(renderedData);
  let isResort: boolean | string = '';
  let isLACountyFee: boolean = false;
  //to display resort or destination fee label after checking description type
  if (selectedHotelRef?.current) {
    let descriptionArray = selectedHotelRef?.current[0]?.node?.property?.basicInformation?.descriptions;
    if (isFlexibleDateSearch) {
      descriptionArray = selectedHotelRef?.current[0]?.node?.basicInformation?.descriptions;
    }
    descriptionArray?.filter((item: { type: { code: string; enumCode?: string } }) => {
      if (item?.type?.enumCode === 'RESORT_FEE_DESCRIPTION') {
        isResort = true;
        isLACountyFee = false;
      } else if (item?.type?.enumCode === 'SURCHARGE_ORDINANCE_COST_DESCRIPTION') {
        isResort = false;
        isLACountyFee = true;
      } else if (item?.type?.enumCode === 'DESTINATION_FEE_DESCRIPTION') {
        isResort = false;
        isLACountyFee = false;
      }
    });
  }
  //if still isResort flag is empty then use resort Flag from uxl
  if (isResort === '') {
    isResort = isFlexibleDateSearch
      ? selectedHotelRef?.current && selectedHotelRef.current[0]?.node?.basicInformation?.resort
      : selectedHotelRef?.current && selectedHotelRef.current[0]?.node?.property?.basicInformation?.resort;
  }

  const toolTipTitle = isResort
    ? dailyResortFeeLabel
    : isLACountyFee
    ? jsonContent?.surchargeTooltipHeadingLabel
    : dailyDestinationFeeLabel;
  const toolTipData =
    !isFlexibleDateSearch &&
    selectedHotelRef?.current &&
    selectedHotelRef.current[0]?.node?.property?.basicInformation?.descriptions &&
    selectedHotelRef.current[0]?.node?.property?.basicInformation?.descriptions.filter(
      (item: { type: { code: string; enumCode?: string }; text: string }) => {
        if (
          item?.type?.enumCode === 'RESORT_FEE_DESCRIPTION' ||
          item?.type?.enumCode === 'DESTINATION_FEE_DESCRIPTION' ||
          item?.type?.enumCode === mandatoryFeeCodes.laCountyFeeCode ||
          item?.text?.toLowerCase().includes('a resort fee of') ||
          item?.text?.toLowerCase().includes('a daily destination fee of') ||
          item?.text?.toLowerCase().includes(mandatoryFeeCodes.laCountyFeeCheck)
        ) {
          return item;
        }
        return null;
      }
    );
  const toolTipList = toolTipData && toolTipData[0]?.text?.split('|');

  return (
    <StyledMapToolTip>
      <Modal
        secondaryClassName={clsx('popup-width', 'tracker', 'custom-position')}
        show={true}
        handleBlur={true}
        popupOpenState={popupOpenState}
        setPopupOpenState={setPopupOpenState}
        role="dialog"
        labelledBy="tooltip-modal"
        modalId="tooltip-modal"
      >
        <div className="tooltip-popup-wrapper">
          <Modal.Header
            className="custom-header-font"
            labelText={toolTipTitle}
            popupHeaderOnCLoseFunc={onCancel}
            popupCloseClassName="popup-close-button"
          ></Modal.Header>
          <Modal.Body className="custom-heights">
            <div className="tooltip-main-wrapper" tabIndex={0} role="document">
              Includes:
              <div className="tooltip-main-content">
                <ul className="custom-ul-props">
                  {toolTipList?.map((item: ReactNode) => {
                    return <li className="custom-list">{item}</li>;
                  })}
                </ul>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            setFeatureSelected={setFeatureSelected}
            viewRateLabel={jsonContent.viewRateLabel}
            viewRatesURL={
              addSubDirectoryPrefix(
                `${NEXT_PUBLIC_AVAILABILITY_SEARCH_URL}${NAVIGATION_URL_CONSTANTS.SM_VIEW_RATES_URL}`
              ) + selectedHotelRef?.current[0]?.node?.property?.id
            }
            className="row-reverse"
            fromToolTip={true}
          ></Modal.Footer>
        </div>
      </Modal>
    </StyledMapToolTip>
  );
};
